// @ts-nocheck
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getTrailerTrackingsV2, GetTrailerTrackingsV2ApiParameter } from "@store/Framework/Services/TrailerServiceV2";
import { TrailerTrackingV2CollectionModel } from "@store/Framework/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type ApiResult = TrailerTrackingV2CollectionModel;
type ApiParameter = GetTrailerTrackingsV2ApiParameter;
type Parameter = ApiParameter & HasOnSuccess<ApiResult> & HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<Parameter, ApiParameter, ServiceResult<ApiResult>>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;

    props.apiParameter = apiParameter;
};

export const DispatchBeginLoad: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/BeginLoadTrailerTrackings",
        parameter: props.apiParameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getTrailerTrackingsV2(props.apiParameter);
};

export const DispatchCompleteLoad: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/CompleteLoadTrailerTrackings",
        parameter: props.parameter,
        collection: props.apiResult.successful ? props.apiResult.result : undefined,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoad,
    RequestDataFromApi,
    DispatchCompleteLoad,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const loadTrailerTrackings = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadTrailerTrackings");
export default loadTrailerTrackings;
